import React from 'react';
import BusinessDevelopmentDedicatedCustomersBody from '../../../shared/dedicated-customers/BusinessDevelopmentDedicatedCustomersBody';
import DataAnalysisNavBar from '../../../../layouts/data-analysis/DataAnalysisNavBar';

const DataAnalysisDedicatedCustomers = () => {
  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <DataAnalysisNavBar currentPage="Dedicated Customers" />
        <BusinessDevelopmentDedicatedCustomersBody />
      </main>
    </div>
  );
};

export default DataAnalysisDedicatedCustomers;
